import axios from 'axios'

const state = {
    clients: [],
    clients_short: [],
};

const actions = {
    getAllClients ({commit}) {
        axios.post('api/clients/get-clients').then(
            response => {
                commit('recieve_clients', response.data.data)
            }
        ).catch(errors =>{
            console.log(errors);
        })
    },
    getAllClientsShort ({commit}, {search}) {
        axios.post('api/clients/get-clients-lite', {
            search: {
                name: search
            }
        }).then(
          response => {
              const res = response.data.map(item => {
                  return {
                      id: item.id,
                      name: item.type === 'buisness_activity' ? item.name + ' ' + item.surname : item.company_name,
                      client_internal: item.client_internal
                  }
              });
              commit('recieve_clients_short', res)
          }
        ).catch(errors =>{
            console.log(errors);
        })
    },
};

const mutations = {
    recieve_clients (state, clients) {
        state.clients = clients;
    },
    recieve_clients_short (state, clients) {
        state.clients_short = clients;
    },

};

const getters = {
    allClients (state) {
        return state.clients
    },
    allClientsShort (state) {
        return state.clients_short
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}
